module.exports = __webpack_public_path__ + "static/media/Ahmed-pdp.5f8fd35b.jpeg";